<script lang="ts" setup>
import { Button, Spin } from 'ant-design-vue';
import { useGetRef } from 'use-api-vue';

import ApiErrors from '@/ui/ApiErrors/index.vue';
import type { ApiResponse, ServerErrors } from '@/util/api/ajax/ApiResponse';

const {
  error: smsError, loading: smsLoading, send: smsSend,
} = useGetRef<ApiResponse<unknown>, unknown, ServerErrors>();
const {
  error: emailError, loading: emailLoading, send: emailSend,
} = useGetRef<ApiResponse<unknown>, unknown, ServerErrors>();

const sendSms = async () => {
  await smsSend('/mfa/sms');
};

const sendEmail = async () => {
  await emailSend('/mfa/email');
};

</script>

<template>
  <div class="text-center mt-6">
    <p class="text-center">
      Having trouble?
    </p>
    <Button
      type="primary"
      :loading="smsLoading"
      class="focusHere"
      @click="sendSms"
    >
      Resend Code
    </Button>
    <ApiErrors v-if="smsError" :error="smsError" />
    <div class="mt-3">
      <p>
        <span
          role="button"
          tabindex="0"
          class="focusHere underline inline-block"
          @click="sendEmail"
          @keyup.enter="sendEmail"
        >
          <Spin :spinning="emailLoading" class="inline">
            Email code instead
          </Spin>
        </span>
      </p>
      <ApiErrors v-if="emailError" :error="emailError" />
    </div>
  </div>
</template>

<style scoped>
.focusHere:focus {
  outline: 2px dotted black!important;
}
</style>
